export const MODULE_TYPE = {
  HOLIDAY: 1,
  ACTIVITY: 2,
  HOTEL: 3,
  FLIGHT: 4,
  BLOG: 5,
  DEALS: 6,
  STATIC: 7,
  COUNTRY_CITY: 8,
  HOME: 9,
  COUPON: 10,
  SEASONAL_DEALS: 11,
};

export function normalizePopupPath(path = "") {
  if (path === "/in") return "/";
  if (path.startsWith("/in/")) return path.replace("/in", "");
  return path;
}

export function getModuleTypeFromRoute(path = "") {
  const cleaned = normalizePopupPath(path);

  if (cleaned.startsWith("/holiday")) return MODULE_TYPE.HOLIDAY;
  if (cleaned.startsWith("/activity")) return MODULE_TYPE.ACTIVITY;
  if (cleaned.startsWith("/stays")) return MODULE_TYPE.HOTEL;
  if (cleaned.startsWith("/flights")) return MODULE_TYPE.FLIGHT;
  if (cleaned.startsWith("/blog") || cleaned.startsWith("/place")) {
    return MODULE_TYPE.BLOG;
  }
  if (cleaned.startsWith("/coupons")) return MODULE_TYPE.COUPON;
  if (cleaned === "/deals") return MODULE_TYPE.DEALS;
  if (cleaned.startsWith("/deals/")) return MODULE_TYPE.SEASONAL_DEALS;
  if (cleaned.startsWith("/page")) return MODULE_TYPE.COUNTRY_CITY;
  if (cleaned === "/") return MODULE_TYPE.HOME;

  return MODULE_TYPE.STATIC;
}

export function shouldSkipSitePopups(path = "") {
  const pathOnly = String(path).split("?")[0].split("#")[0];
  const cleaned = normalizePopupPath(pathOnly);
  return (
    cleaned.includes("/thank-you") ||
    cleaned.includes("/booking-success") ||
    cleaned.includes("/booking-failed") ||
    cleaned.includes("/flights-mobile") ||
    cleaned.includes("/stays-mobile") ||
    cleaned.includes("/package-booking") ||
    cleaned.includes("/profile") ||
    cleaned.includes("/cart")
  );
}

export function formatEngageMinutes(minutes) {
  const value = Number(minutes);
  if (!Number.isFinite(value) || value <= 0) return "";
  return value === 1 ? "1 minute ago" : `${value} minutes ago`;
}

export function normalizeEngageItem(item = {}) {
  const description = String(
    item.description || item.message || item.bodyText || item.subTitle || ""
  )
    .replace(/\r\n/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const minutes = item.minutes ?? item.minute;
  const timeAgo =
    item.timeAgo ||
    item.time ||
    item.createdOn ||
    formatEngageMinutes(minutes);

  return {
    id: item.id || item.engageId || item.notificationId || "",
    title: item.title || item.heading || item.headerText || "",
    description,
    thumbnail:
      item.thumbnail ||
      item.Thumbnail ||
      item.imageUrl ||
      item.ImageUrl ||
      item.image ||
      item.thumbnailUrl ||
      item.thumbImage ||
      "",
    redirectionLink:
      item.redirectionLink ||
      item.RedirectionLink ||
      item.redirectUrl ||
      item.link ||
      "",
    minutes: Number(minutes) || 0,
    timeAgo,
    statusFlag: item.statusFlag !== false,
  };
}

function extractEngageArray(root) {
  if (Array.isArray(root)) return root;
  if (Array.isArray(root?.engageList)) return root.engageList;
  if (Array.isArray(root?.EngageList)) return root.EngageList;
  if (Array.isArray(root?.data)) return root.data;
  if (Array.isArray(root?.Data)) return root.Data;
  if (Array.isArray(root?.items)) return root.items;
  if (Array.isArray(root?.result)) return root.result;
  if (Array.isArray(root?.list)) return root.list;

  const nested = root?.data ?? root?.Data;
  if (nested && typeof nested === "object") {
    return extractEngageArray(nested);
  }

  return [];
}

export function normalizeEngageList(response) {
  const root = response?.data ?? response ?? {};
  const list = extractEngageArray(root);

  return list
    .map(normalizeEngageItem)
    .filter(
      (item) => item.statusFlag !== false && (item.title || item.description)
    );
}

export function normalizeDestinationOptions(response) {
  const root = response?.data ?? response ?? {};
  const list = Array.isArray(root)
    ? root
    : Array.isArray(root.destinations)
      ? root.destinations
      : Array.isArray(root.data)
        ? root.data
        : [];

  return list
    .map((item) => {
      if (typeof item === "string") return item;
      return (
        item.destination ||
        item.name ||
        item.cityName ||
        item.label ||
        ""
      );
    })
    .filter(Boolean);
}

export function isPopupApiSuccess(response) {
  const status = String(response?.status || "").toLowerCase();
  return !status || status === "success";
}
